import { useState } from 'react';
import { chatArchive } from '@/mocks/exposure';
import { SectionHead, Tag } from './ui';

const channels = ['全部', '微信', 'QQ', '群聊', '语音转文字', '长文记录'];

export default function ChatSection() {
  const [active, setActive] = useState('全部');
  const shown = active === '全部' ? chatArchive : chatArchive.slice(0, 5);

  return (
    <div className="bg-background-100">
      <section
        id="chat"
        className="mx-auto grid w-full max-w-[1280px] gap-6 px-4 py-9 md:px-6 md:py-14 lg:grid-cols-4"
      >
        {/* 左：维度栏 */}
        <div className="lg:col-span-1">
          <SectionHead no="02" title="聊天记录" sub="按人物与事件归集的记录切片" more="全部档案" href="#" />
          <div className="rounded-xl border border-background-200 bg-background-50 p-4">
            <p className="mb-3 text-xs font-bold tracking-wide text-foreground-500">按记录形态筛选</p>
            <div className="flex flex-wrap gap-2">
              {channels.map((c) => (
                <button
                  key={c}
                  onClick={() => setActive(c)}
                  className={`inline-flex items-center whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition ${
                    active === c
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <div className="mt-4 rounded-lg border border-accent-200 bg-accent-50 p-3.5">
              <p className="flex items-center gap-1.5 text-xs font-bold text-accent-900">
                <i className="ri-shield-check-line" /> 查证提示
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                记录均保留来源与语境说明，关键句标注原始上下文，供与公开口径逐句对照。
              </p>
            </div>
          </div>
        </div>

        {/* 右：密集记录行 */}
        <div className="rounded-xl border border-background-200 bg-background-50 lg:col-span-3">
          <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
            <span className="text-sm font-bold text-foreground-800">最新归档 · {active}</span>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
              <i className="ri-database-2-line text-primary-500" /> 累计 1,064 份
            </span>
          </div>
          <ul className="divide-y divide-background-100">
            {shown.map((c, idx) => (
              <li key={idx}>
                <a href="#" className="group flex items-center gap-3 px-4 py-3 transition hover:bg-background-100/70 md:px-5">
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                      idx % 2 ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    <i className="ri-chat-3-line text-lg" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-1 block text-sm font-medium text-foreground-800 group-hover:text-primary-700 md:text-[15px]">
                      {c.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                      <Tag tone="secondary">{c.type}</Tag>
                      <span className="whitespace-nowrap">{c.person}</span>
                      <span className="hidden whitespace-nowrap sm:inline">· {c.pages}</span>
                    </span>
                  </span>
                  <span className="hidden shrink-0 text-right sm:block">
                    <span className="block text-xs font-semibold text-foreground-600">{c.time}</span>
                    <span className="mt-1 inline-flex items-center gap-1 text-[11px] text-accent-600">
                      <i className="ri-fire-fill" /> {c.heat}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line hidden shrink-0 text-lg text-foreground-300 group-hover:text-primary-500 lg:block" />
                </a>
              </li>
            ))}
          </ul>
          <div className="flex justify-center border-t border-background-100 py-3">
            <button className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-xs font-medium text-foreground-600 transition hover:border-primary-300 hover:text-primary-600">
              加载更多记录 <i className="ri-loader-4-line" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}